import api from '../../api/client';
import React, { useState, useEffect } from "react";
import { Table, Tag, Spin, Card, Typography } from "antd";
import dayjs from "dayjs";
import axios from "axios";
import config from "../../config";

const { Title } = Typography;

const LeaveHistory = ({ userId }) => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const environment =
    window.location.hostname === "localhost" ? "development" : "production";
  const apiUrl = config[environment].apiUrl;

  const fetchLeaveRequests = async () => {
    try {
      const { data } = await api.get(
        `/leave/requests?userId=${userId}`,
      );
      const userRequests = data.filter((req) => req.user_id === userId);
      setRequests(userRequests);
    } catch (error) {
      console.error("Error fetching leave requests:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchLeaveRequests();
    }
  }, [userId]);

  const columns = [
    {
      title: "Dates",
      dataIndex: "start_date",
      key: "dates",
      render: (_, record) =>
        `${dayjs(record.start_date).format("MMM DD")} - ${dayjs(
          record.end_date,
        ).format("MMM DD, YYYY")}`,
      sorter: (a, b) => dayjs(a.start_date).unix() - dayjs(b.start_date).unix(),
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (text) => (
        <span style={{ textTransform: "capitalize" }}>{text}</span>
      ),
      sorter: (a, b) => a.type.localeCompare(b.type),
    },
    {
      title: "Days",
      dataIndex: "leave_days",
      key: "days",
      sorter: (a, b) => a.leave_days - b.leave_days,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let color = "";
        if (status === "approved") color = "green";
        else if (status === "rejected") color = "red";
        else color = "orange";
        return <Tag color={color}>{status.toUpperCase()}</Tag>;
      },
      filters: [
        { text: "Approved", value: "approved" },
        { text: "Pending", value: "pending" },
        { text: "Rejected", value: "rejected" },
      ],
      onFilter: (value, record) => record.status === value,
    },
    {
      title: "Request Time",
      dataIndex: "created_at",
      key: "created_at",
      render: (date) => dayjs(date).format("MMM DD YYYY, HH:mm:ss"),
      sorter: (a, b) => dayjs(a.created_at).unix() - dayjs(b.created_at).unix(),
    },
  ];

  return (
    <Card title="Leave History" bordered={false}>
      <Spin spinning={loading}>
        <Table
          size="small"
          columns={columns}
          dataSource={requests}
          rowKey="id"
          pagination={{ pageSize: 20, showSizeChanger: true }}
          loading={loading}
          scroll={{ x: "max-content" }}
        />
      </Spin>
    </Card>
  );
};

export default LeaveHistory;
